module.exports = __webpack_public_path__ + "media/system-beep-buzzer-fail.96fa54dc.wav";